/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.account
 */
SignupService.$inject = [
    '$rootScope',
    'AccountAuthService',
    'UserApiConsumerService',
    'WITHOUT_CREDENTIALS',
];
function SignupService(
    $rootScope,
    AccountAuthService,
    UserApiConsumerService,
    WITHOUT_CREDENTIALS
) {
    const _pub = {};
    let _indexDoesUserExist = null;
    let _passwordSaved = null;
    let _requiredEmail = null;
    let _nextUrl = null;

    _pub.signUpModalOpenedCallBack = function () {};

    _pub.signInPasswordModalOpenedCallBack = function () {};

    /**
     * Broadcast method to update variables in in the login directives.
     */
    _pub.updateLoginCredentials = function (email) {
        $rootScope.$broadcast("login-credentials-set", email);
    };

    /**
     * Verifies if the email provided is registered.
     *
     * @param email
     * @returns {*}
     */
    _pub.doesUserEmailExist = function(email) {
        var requestParams = {
            params: {
                "email": email
            }
        };
        return UserApiConsumerService.get(
            'api/1.0/email-exists/', requestParams
        ).then(function(response) {
            var data = response.data;
            _indexDoesUserExist = {
                'exists': data.exists,
                'password_set': data.password_set
            };
        }, function () {
            _indexDoesUserExist = null;
        });
    };

    /**
     * Returns bool if a user exists and registers email for
     * future user profile signup if email is not in the system.
     *
     * @returns {*}
     */
    _pub.getDoesUserExist = function() {
        return _indexDoesUserExist;
    };

    /**
     * Service to set a new password for a new existing user.
     *
     * @param {String} email
     * @param {String} newPassword
     * @param {String} confirmPassword
     * @returns {Promise}
     */
    _pub.saveUserPassword = function(email, newPassword, confirmPassword) {

        var data = {
            'email': email,
            'password1': newPassword,
            'password2': confirmPassword
        };

        return UserApiConsumerService.post('api/1.0/rest-auth/registration/', data, WITHOUT_CREDENTIALS)
            .then(
                // success
                function (response) {
                    return AccountAuthService.logIn(data.email, data.password1).then(function () {
                        _passwordSaved = {'created': true};
                    });
                },
                // error
                function (response) {
                    var _data = response.data;

                    _passwordSaved = {'created': false};

                    if ('non_field_errors' in _data) {
                        _passwordSaved.error = _data.non_field_errors;
                    } else if ('password' in _data) {
                        _passwordSaved.error = _data.password[0];
                    } else if ('error' in _data) {
                        _passwordSaved.error = _data.error[0];
                    }
                }
            );
    };

    /**
     * returns a bool if the password was saved
     * @returns {*}
     */
    _pub.wasPasswordSaved = function() {
        return _passwordSaved;
    };

    /**
     * Sets the required email value to the provided string. If the value is not
     * a string, the required email is set to `null` instead, clearing the value.
     *
     * The purpose of the required email is to enforce that user creates an account
     * (or logs in) with a specific email address. When a user attempts to sign up
     * and the required email is set to a string, the value should be set to the
     * email field as readonly. After the user has logged in, the value should be
     * set to `null` so that future attempts don't require the email address.
     *
     * @param {string} email - The email string to set as the required email.
     *                         Any non-string value will set the email to `null`.
     */
    _pub.setRequiredEmail = function(email) {
        _requiredEmail = typeof email === "string" ? email : null;
    };

    /**
     * Returns the value of the required email. If there is an email address that
     * is required to be used when logging in, the value will be a string. Otherwise,
     * this function returns `null`.
     *
     * @returns {string | null} The email that should be required when logging in,
     *                          or null if none is required.
     */
    _pub.getRequiredEmail = function() {
        return _requiredEmail;
    };

    /**
     * Gets the url to be used for redirecting the user after login.
     *
     * @returns {String} Url.
     */
    _pub.getNextUrl = function() {
        return _nextUrl;
    }

    /**
     * Sets the url to be used for redirecting the user after login.
     *
     * @param {String} url - The url that will be set.
     */
    _pub.setNextUrl = function(url) {
        _nextUrl = url || null;
    };

    return _pub;
}

module.exports = SignupService;
